export type DashboardVisibility = Readonly<{
  /** A read refused for want of a context it already carried — a bare one is
   * defaulted and retried before it can reach here. */
  hasUnresolvedContext: boolean;
}>;

export const showsFiltersUnavailable = (
  hasFiltersError: boolean,
  { hasUnresolvedContext }: DashboardVisibility,
): boolean => hasFiltersError && !hasUnresolvedContext;
